<template>
    <div class="justify-center align-center d-flex mt-12">
        <form @submit.prevent="submit">
            <h2 class="mb-3">{{ $t('organization.selectStore') }}</h2>
            <v-autocomplete
                class="mb-5"
                v-model="selectedOrganization"
                :items="userOrganizations.organizations"
                item-text="Name"
                return-object
                :label="$t('anOrganization')"
                outlined
                :no-data-text="$t('noDataAvailable')"
                hide-details
                item-value="id"
            >
                <template v-slot:item="data">
                    <div>
                        <div><b>{{data.item.Name}}</b></div>
                        <div>
                            <span v-if="data.item.Street">{{data.item.Street}}</span>
                            <span v-if="data.item.PostalCode">, {{data.item.PostalCode}}</span>
                            <span v-if="data.item.Place">, {{data.item.Place}}</span>
                            <span v-if="data.item.CountryCode">, {{data.item.CountryCode}}</span>
                        </div>
                    </div>
                </template>
            </v-autocomplete>

            <v-btn
                type="submit"
                :disabled="Object.keys(selectedOrganization).length === 0"
                width="100%"
                color="success"
            >
                {{ $t('apply') }}
            </v-btn>
        </form>
    </div>
</template>

<script>
    import config from '../config'
    import Axios from 'axios'
    // import {i18n} from '@/plugins/i18n'
    import router from '@/router'
    import { mapMutations } from 'vuex'
    const qs = require('querystring')

    export default {
      data() {
        return {
            selectedOrganization: {},
        }
      },
      computed: {
        userOrganizations() {
            return this.$store.getters.GET_USER_ORGANIZATIONS
        }

      },
      methods: {
          ...mapMutations(['SET_LOGIN_USER', 'SET_USER_ORGANIZATIONS']),

        async submit() {
            const payload = {
                username: this.userOrganizations.userName,
                state: this.userOrganizations.state,
                guid: this.userOrganizations.guid,
                role: this.userOrganizations.role,
                permissions: this.userOrganizations.permissions,
                organizationId: this.selectedOrganization.Id,
                OrganizationName: this.selectedOrganization.Name,
                OrganizationsHId: this.selectedOrganization.OrganizationsHId,
                CountryCode: this.selectedOrganization.CountryCode,
                SetLoadUnloadTimeSign: this.selectedOrganization.SetLoadUnloadTimeSign,
                DashboardPaymentSign: this.selectedOrganization.DashboardPaymentSign,
                DashboardDisplaySign: this.selectedOrganization.DashboardDisplaySign,
            }
            Axios.post(config.apiBaseUrl + 'store-number/token',  qs.stringify(payload))
                .then((response) => {
                    if(response.status === 200) {
                        this.setUser(response.data)
                    }
                    
                })
                .catch((error) => {
                    /* eslint-disable */
                    console.error('error : ', 
                        {
                            status: error.response.status,
                            statusText: error.response.statusText,
                            message: error.response.data
                        }
                    )
                });       
        },

        setUser(userData) {
            localStorage.setItem('userName', userData.username)
            localStorage.setItem('accessToken', userData.access_token)
            localStorage.setItem('role', userData.role)
            localStorage.setItem('userId', userData.userId)
            localStorage.setItem('guid', userData.guid)
            localStorage.setItem('organization', userData.organization)
            localStorage.setItem('organizationId', userData.organizationId)
            localStorage.setItem('lang', 'en')
            localStorage.setItem('permissions', userData.permissions)
            localStorage.setItem('loginMS', true)
            if(userData.showNewDashboardSign === 'True') localStorage.setItem('showNewDashboardSign', 'true');
            if(userData.showNewDashboardSign === 'False') localStorage.setItem('showNewDashboardSign', 'false');
            

            this.SET_LOGIN_USER(userData);
            // router.push(i18n.locale + '/orders') 
            this.SET_USER_ORGANIZATIONS({})
            router.push('/en' + '/orders') 
        },
        
      },
    }
</script>

<style></style>